export default __webpack_public_path__ + "static/media/student-work9.4a9b071d.jpeg";